var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProof2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_1231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416 0H96C70.5479 0.0282331 46.1463 10.1516 28.1489 28.1489C10.1516 46.1463 0.0282331 70.5479 0 96L0 416C0.0282331 441.452 10.1516 465.854 28.1489 483.851C46.1463 501.848 70.5479 511.972 96 512H416C441.452 511.972 465.854 501.848 483.851 483.851C501.848 465.854 511.972 441.452 512 416V96C511.972 70.5479 501.848 46.1463 483.851 28.1489C465.854 10.1516 441.452 0.0282331 416 0ZM96 64H416C424.487 64 432.626 67.3714 438.627 73.3726C444.629 79.3738 448 87.5131 448 96V416C448.006 420.202 447.179 424.364 445.568 428.245C443.957 432.127 441.593 435.65 438.613 438.613L252.331 252.331C236.328 236.333 214.627 227.346 192 227.346C169.373 227.346 147.672 236.333 131.669 252.331L64 320V96C64 87.5131 67.3714 79.3738 73.3726 73.3726C79.3738 67.3714 87.5131 64 96 64Z",
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.667 213.333C360.123 213.333 384.001 189.455 384.001 160C384.001 130.545 360.123 106.667 330.667 106.667C301.212 106.667 277.334 130.545 277.334 160C277.334 189.455 301.212 213.333 330.667 213.333Z",
    fill: "#16A34A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_1231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProof2);
export default __webpack_public_path__ + "static/media/Proof 2.ac9ecdc6a2c2927a4d43adfe700651cc.svg";
export { ForwardRef as ReactComponent };